var render = function render(_c,_vm){return _c('div',{staticClass:"C-portal-player"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }